


































import { Vue, Component } from "vue-property-decorator";

import IconLogIn from "@/components/icons/IconLogIn.vue";

import { personalModule } from "@/plugins/store-accessors";

interface Refs {
  [key: string]: HTMLDivElement;
}

@Component({
  components: { IconLogIn },
})
export default class DropDownMenu extends Vue {
  opened = false;

  get initialData() {
    return [
      {
        title: this.user?.name,
        icon: this.getIcon("IconHome"),
        action: () => this.route("/account"),
      },
      {
        title: "Заказы",
        icon: this.getIcon("IconList"),
        action: () => this.route("/account/orders"),
      },
      {
        title: "Типы цен",
        icon: this.getIcon("IconRuble"),
        action: () => this.route("/account/prices"),
      },
      {
        title: "Выйти",
        icon: this.getIcon("IconLogOut"),
        action: this.logout,
      },
    ];
  }

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  get user() {
    return personalModule.getUser;
  }

  logout() {
    return personalModule.logout();
  }

  showLoginModal() {
    return personalModule.showLoginModal();
  }

  getIcon(icon: string) {
    return () => import(`@/components/icons/${icon}.vue`);
  }

  handleTrigger() {
    this.route("/account");
  }

  handleOpen() {
    this.opened = true;
    document.addEventListener(`click`, this.toggle);
  }

  handleClose() {
    this.opened = false;
    document.removeEventListener(`click`, this.toggle);
  }

  toggle(event: Event) {
    const { drop, trigger } = this.$refs as Refs;
    const target = event.target as HTMLDivElement;
    if (!target?.isEqualNode(trigger) || drop.contains(event.target as Node)) {
      this.handleClose();
    }
  }

  route(route: string) {
    this.$router.push(route);
    this.handleClose();
  }
}
